// @flow

const getMaskedCurrency = (currency: string): string => {
  if (currency === 'USD') return 'USDC';

  return currency;
};

export default getMaskedCurrency;
